import { render } from "./RisingArrowIcon.vue?vue&type=template&id=e8d2b006"
import script from "./RisingArrowIcon.vue?vue&type=script&lang=js"
export * from "./RisingArrowIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__